import { render, staticRenderFns } from "./Hres.vue?vue&type=template&id=2623683c&"
import script from "./Hres.vue?vue&type=script&lang=js&"
export * from "./Hres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports